import { Button, Col, Divider, Flex, Modal, Row, Space } from "antd";
import { useAppSelector, useAppDispatch } from "../../../../util/hooks";
import * as Icon from "@ant-design/icons";
import { deletarDetalheConfiguracaoImportacaoVenda, listarDetalheConfiguracaoImportacaoVenda } from "../../../../services/detalheConfiguracaoImportacaoVendaService";
import {
  setEntityDetalheConfiguracaoImportacaoVenda,
  setModalCadastrarDetalheConfiguracaoImportacaoVenda,
  setModalDeletarDetalheConfiguracaoImportacaoVenda,
} from "../../../../redux/slices/detalheConfiguracaoImportacaoVenda/detalheConfiguracaoImportacaoVendaSlice";
import { useEffect } from "react";
import { formatPercent } from "../../../../util/dinheiroBRAuxiliar";
import { DetalheConfiguracaoImportacaoVendaModel } from "../../../../models/detalheConfiguracaoImportacaoVenda/detalheConfiguracaoImportacaoVendaModel";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { ItemMenuAcoes } from "../../../../models/sistema/itemMenuAcoes";
import AcoesComponent from "../../../../components/table/acoesComponent";
import TableComponent from "../../../../components/table/tableComponent";
import MensagemModal from "../../../../components/modal/mensagem";

dayjs.locale("pt-br");

const DetalheConfiguracaoImportacaoVendaModal = () => {
  //estados globais
  const configuracaoImportacaoVendaState = useAppSelector((state) => state.configuracaoImportacaoVenda);
  const detalheConfiguracaoImportacaoVendaState = useAppSelector((state) => state.detalheConfiguracaoImportacaoVenda);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais

  useEffect(() => {
    dispatch(listarDetalheConfiguracaoImportacaoVenda(detalheConfiguracaoImportacaoVendaState.busca));
  }, []);

  const voltar = () => {
    dispatch(setModalCadastrarDetalheConfiguracaoImportacaoVenda(false));
  };

  const goDeletar = (value: DetalheConfiguracaoImportacaoVendaModel) => {
    dispatch(setEntityDetalheConfiguracaoImportacaoVenda(value));
    dispatch(setModalDeletarDetalheConfiguracaoImportacaoVenda(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarDetalheConfiguracaoImportacaoVenda(false));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<DetalheConfiguracaoImportacaoVendaModel> = [
    {
      title: "VIGÊNCIA",
      dataIndex: "dataVigencia",
      align: "center",
      width: 80,
      render: (_, record) => <>{record.dataVigencia && dayjs(record.dataVigencia).format("DD/MM/YYYY")}</>,
    },
    {
      title: "% VENDA FÍSICA (CAP)",
      dataIndex: "percentualComissaoVendaFisicaCapitalizacao",
      align: "right",
      width: 90,
      render: (_, record) => <>{record.percentualComissaoVendaFisicaCapitalizacao && formatPercent(record.percentualComissaoVendaFisicaCapitalizacao)}</>,
    },
    {
      title: "% VENDA FÍSICA (ENT)",
      dataIndex: "percentualComissaoVendaFisicaEntidade",
      align: "right",
      width: 90,
      render: (_, record) => <>{record.percentualComissaoVendaFisicaEntidade && formatPercent(record.percentualComissaoVendaFisicaEntidade)}</>,
    },
    {
      title: "% VENDA ONLINE (CAP)",
      dataIndex: "percentualComissaoVendaOnlineCapitalizacao",
      align: "right",
      width: 90,
      render: (_, record) => <>{record.percentualComissaoVendaOnlineCapitalizacao && formatPercent(record.percentualComissaoVendaOnlineCapitalizacao)}</>,
    },
    {
      title: "% VENDA ONLINE (ENT)",
      dataIndex: "percentualComissaoVendaOnlineEntidade",
      align: "right",
      width: 90,
      render: (_, record) => <>{record.percentualComissaoVendaOnlineEntidade && formatPercent(record.percentualComissaoVendaOnlineEntidade)}</>,
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <TableComponent columns={columns} data={detalheConfiguracaoImportacaoVendaState.list} loading={detalheConfiguracaoImportacaoVendaState.loading} />
      <Divider />
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<Icon.CloseOutlined />}>
              FECHAR
            </Button>
          </Space>
        </Col>
      </Row>
      <Modal title={"REMOVER CONFIGURAÇÃO DE IMPORTAÇÃO"} centered width={350} open={detalheConfiguracaoImportacaoVendaState.modalDeletar} closable={false} onCancel={closeModalDeletar} footer={null}>
        <MensagemModal
          text="Deseja remover o detalhe da configuração?"
          action={deletarDetalheConfiguracaoImportacaoVenda({ value: detalheConfiguracaoImportacaoVendaState.entity.id, busca: detalheConfiguracaoImportacaoVendaState.busca })}
          close={setModalDeletarDetalheConfiguracaoImportacaoVenda(false)}
        />
      </Modal>
    </Flex>
  );
};

export default DetalheConfiguracaoImportacaoVendaModal;
